/*global window, _, MOVE_DATA, localStorage, JST, swap_login_header_text:true, raasSWAP */
/* exported swap_login_header_text */
/** AB TESTS **/
import { focusRequestLead } from 'shared_non_critical/lead-open-keyboard.js';
import { abOpenHouseTimePicker, abOpenHouseDatePicker, abSetDateTime, abPopulateForm } from "../quick_view/optimization/ab-hlt-open-house";
import { toggleOrEmailMeBtn } from "../quick_view/optimization/ab-only-text-cta-lead";
import { focusTextLead } from "../quick_view/optimization/ab-open-keyboard-txt-lead";

(function (MOVE) {

  var removeErrorModal = function() {
    if ($('#shareUnavailable').length) {
      // Make sure error modal is closed (if any)
      if ($('#shareUnavailable').is(':visible')) {
        $('#shareUnavailable').modal('hide');
      }

      //Make sure the error modal gets removed
      $('#shareUnavailable, .modal-backdrop').remove();
    }
  };

  var showErrorTryAgainModal = function(target, modelData) {
    // Append the new error modal
    $('#modal-container').append(
      JST['templates/modal_error']({
        hasTarget:  true,
        target:     target,
        property:   JSON.stringify(modelData)
      })
    );

    // Open the error modal
    $('#shareUnavailable').modal();
  };

  var showErrorModal = function() {
    // Append the new error modal
    $('#modal-container').append(
      JST['templates/modal_error']({
        hasTarget: false
      })
    );

    // Open the error modal
    $('#shareUnavailable').modal();
  };

  var initModalData = function(target, modelData, additionalData, source) {
    if (target === '#ldpBottomLeadModal') {
      var $sellDateSelect = $(target).find('.selectpicker');
      if($sellDateSelect){
        $sellDateSelect.selectpicker();
      }
      MOVE.LDP.LeadForm.init('gallery_request_more_details', modelData , MOVE.LDP.PhotoGallery.hideLeadForm);
      MOVE.LDP.SellerLead.init();
    }
    else if (target === '#request-private-showing') {
      MOVE.LDP.LeadForm.init('request-private-showing', modelData);
    }
    else if (target.includes('#homes-around-card')) {
      MOVE.LDP.LeadForm.init(target.replace(/#/, ''), modelData);
    }
    else if (target === '#shareEmailModal') {
      MOVE.ShareEmailModal.init();
    }
    else if (target === '#mobileShareOptionsModal') {
      MOVE.ShareEmailModal.init();
    }
    else if (target === '#rental-lead-free-moving-quotes-modal') {
      MOVE.LDP.RentalLeadFreeMovingQuotesModal.init();
    }
    else if (target === '#rental-lead-moving-modal') {
      MOVE.LDP.RentalLeadMovingModal.init(additionalData.position, additionalData.placement);
    }
    else if (target === '#modal-rental-floorplan') {
      MOVE.LDP.RentalsFloorplanModal.init(additionalData);
      MOVE.LDP.LeadForm.init("modal-rental-floorplan", modelData);
    }
    else if (target === '#mortgagePaymentModal') {
      MOVE.LDP.MortgagePayment.init();
    }
    else if (target === '#moving-calculator-modal') {
      MOVE.MovingEstimateModal.init(additionalData.calculation);
    }
    else if (target === '#leadSimpleThankYouVeterans' || target === '#leadSimpleThankYouShared') {
      MOVE.LDP.LeadSimpleThankyouModal.init(
        target, additionalData.isVeteran, additionalData.creditScore, additionalData.isNearbyHomeCard
      );
    }
    else if (/^#srp-lead-modal/.test(target)) {
      // does target start with #srp-lead-modal ?
      MOVE.SRP.CardLead.init(target, additionalData);
    }
    else if (target === '#pdp-contact-local-agent-modal') {
      var propertyData;
      if (modelData.is_nearby_home_card) {
        propertyData = Object.assign(modelData, {
          lead_placement: 'ldp:homes-near-street:contact-neighborhood-expert',
        });
      }
      MOVE.LDP.ContactLocalAgentModal.init(propertyData);
    }
    else if (target === '#fs-matterport-modal') {
      MOVE.MatterportModal.init(target, additionalData);
    }
    else if (target === '#note-input-modal') {
      MOVE.LDP.NoteComponent.initModal();
    }
    else if (target === '#off-market-edit-facts-modal') {
      MOVE.DOMHelper.initPopOver($(".edited-facts-header"));
      hideAdditionalOffmarketEditedData(source);
    }
    else if (target === '#textInputModal') {
      /* LGWEB-160 */
      if(MOVE_DATA.ab_only_txt_mweb === "V1" && !MOVE_DATA.is_flipped_market) {
        $('#srp-lead-modal').modal('hide');
        var abOnlyTxtCtaTextMe = additionalData.target.attributes['data-ab-only-text-cta-text-me'] ? true : false;
        var abLeadSubmitted    = additionalData.target.attributes['data-ab-lead-submitted'];
        toggleOrEmailMeBtn(target, abOnlyTxtCtaTextMe, abLeadSubmitted);
      }
      /* END LGWEB-160 */

      /* LGWEB-162 */
      if (MOVE_DATA.ab_open_keyboard_txt === "V1") {
        focusTextLead();
      }
      /* END LGWEB-162 */

      const omtag = additionalData.target && additionalData.target.attributes['data-omtag'] ? additionalData.target.attributes['data-omtag'].value : '';
      MOVE.LEAD.TextInputModal.init(omtag);
    }
    else if (target === '#scheduleTourModal') {
      MOVE.LEAD.ScheduleTourModal.init();
    }

    // focus and open keyboard
    if(MOVE_DATA.isPhone && MOVE_DATA.adobeDTM.propertyStatus === 'for_sale')  {
      focusRequestLead();
    }
    //LGWEB-14 AB Test
    if (MOVE_DATA.ab_schedule_tour === 'V2' && !MOVE_DATA.is_flipped_market) {
      let $modalContainer = $('#modal-container');
      abOpenHouseTimePicker();
      abOpenHouseDatePicker();
      MOVE.DOMHelper.initPopOverHover($('.lead_form_tcpa_text'))
      Promise.resolve()
      .then( () => {
        $modalContainer.on('shown.bs.modal', function () {
          if ($modalContainer.hasClass('oh-request-modal')) {
            $(this).find('.op-datetimepicker').removeClass('hide');
            abSetDateTime();
            abPopulateForm();
          }
        });
      });
      $modalContainer.on('hidden.bs.modal', function () {
        $modalContainer.removeClass('oh-request-modal');
        $(this).find('.op-datetimepicker').addClass('hide');
      });
    } else {
      MOVE.DOMHelper.initPopOverHover($('.lead_form_tcpa_text'));
    }
  };

  var removeSaveInThankYouModal = function(){
    if (MOVE_DATA.propertyDetails) {
      if (MOVE_DATA.propertyDetails.saved_resource_id) {
        $("#save-content-wrapper").hide();
      }
      else {
        $("#save-content-wrapper").show();
      }
    }
  };

  var fetchModal = function(target, modelData = {}, additionalData, source) {
    if (!window.modals) window.modals = [];

    // keep track of target modals
    if (window.modals.indexOf(target) >= 0) {
      return
    } else {
      window.modals.push(target);
    }

    var propertyInstance = modelData.is_nearby_home_card ? modelData.property_id : null;
    var targetForModalFetch = target.includes('#homes-around-card') ? 'homes_around_card' : target.replace(/#/, '');

    let moddify_property = additionalData.property || modelData;
    if(!moddify_property.saved_resource_id){
      moddify_property.saved_resource_id = MOVE_DATA.subResId;
    }
    var data = $.extend(
      MOVE.DOMHelper.getUrlParams(),
      {
        target:         targetForModalFetch,
        property_slug:  window.location.pathname.split('/').pop(),
        // on srp additionalData will store property info in additionalData
        // on ldp we rely on model.getData
        property:       JSON.stringify(moddify_property),
        propertyInstance
      }
    );

    removeErrorModal();

    // add explicit return to access promise
    return $.post('/properties/modals', data)
      .done(function(data) {
        // Append the modal HTML
        $('#modal-container').append(data.html);

        // Trigger a custom event after DOM injection
        $(document).trigger('modalInserted');

        // Initialize modal data
        initModalData(target, modelData, additionalData);

        // Open Modal
        $(target).modal();

        // Binds action buttons to close modal
        if ($(target).find('.modal-actions > a.btn').length) {
          $(target).find('.modal-actions > a.btn').on('click', function() {
            $(target).modal('hide');
          });
        }
        if( target === '#shareEmailThankYou') {
          removeSaveInThankYouModal();
        }
        if(target === '#off-market-edit-facts-modal') {
          hideAdditionalOffmarketEditedData(source);
        }
      })
      .fail(function() {
        showErrorTryAgainModal(target);
      });
  };

  var hideAdditionalOffmarketEditedData = function (data_source) {
    if(data_source === 'info-icon') {
      $('.show-additional-data').hide();
    }
    else {
      $('.show-additional-data').show();
    }
  }

  var raasSwap = function (data, opts) {
    let swap_login_header_text;
    if (opts.source) {
      switch (opts.source) {
        case 'save_home':
          swap_login_header_text = "Save all the homes you love in one place"
          break;
        case 'save_search':
          swap_login_header_text = "Save this search and get new home notifications fast"
          break;
        case 'save_note':
          swap_login_header_text = "Save notes and homes you love in one place"
          break;
        default:
          swap_login_header_text;
          break;
      }
    }
    raasSWAP(data, null, opts.triggerLocation);
  };

  MOVE.ModalHelper = {
    fetchModal: fetchModal,
    initModalData: initModalData,
    removeErrorModal: removeErrorModal,
    showErrorModal: showErrorModal,
    removeSaveInThankYouModal: removeSaveInThankYouModal,
    raasSwap: raasSwap
  };

}(MOVE));



// WEBPACK FOOTER //
// ./shared_critical/modal_helper.js